import { legalTermsQuery } from "@/api/legalTerms";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/legal/$termsId")({
  component: lazyRouteComponent(() => import("./+LegalTermsDetailPage")),
  beforeLoad: ({ params }) => ({ breadcrumb: params.termsId }),
  loader: ({ params }) => {
    queryClient.prefetchQuery(legalTermsQuery(params.termsId));
  },
  head: () => ({ meta: seo({ title: "Legal Terms" }) }),
});
